import {
    Alert,
    Button,
    Checkbox,
    Collapse,
    FormControlLabel,
    InputAdornment,
    Tooltip,
} from '@mui/material'
import { Input } from '@nextui-org/react'
import cn from 'classnames'
import moment from 'moment'
import qs from 'qs'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ErrorNote from '../../components/common/util/ErrorNote'
import Link from '../../components/common/util/input/Link'
import { floatRegEx } from '../../components/editor/EditorComponents'
import { post } from '../../components/helpers/Api'
import {
    formatHoney,
    formatNumber,
    formatPercentage,
    formatWAX,
} from '../../components/helpers/FormatLinks'
import {
    getBoostAction,
    getHoneyBalance,
    performLogin,
} from '../../components/helpers/WaxApi'
import LoadingIndicator from '../../components/loadingindicator'
import Page from '../../components/page/Page'
import { Context, useSharedState } from '../../components/waxplorer/Waxplorer'
import config from '../../config.json'

const Cpu4uPage = (props) => {
    const { t } = useTranslation('common')

    const CPU_ACCOUNTNAME = 'nfthivecpu4u'
    const CPU_POOL1NAME = 'nfthivecpup1'
    const CPU_POOL2NAME = 'nfthivecpup2'
    const CPU_POOL3NAME = 'nfthivecpup3'
    const [days, setDays] = useState(1)
    const [price, setPrice] = useState(1)
    const [isLoading, setIsLoading] = useState(null)
    const [error, setError] = useState(null)
    const [message, setMessage] = useState(null)
    const [payInHoney, setPayInHoney] = useState(false)

    const [fees, setFees] = useState(1.0)
    const [honeyFactor, setHoneyFactor] = useState(1.0)

    const [honeyBalance, setHoneyBalance] = useState(null)

    let values =
        typeof window !== 'undefined'
            ? qs.parse(
                  window.location.search.substring(
                      1,
                      window.location.search.length,
                  ),
              )
            : []

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const [receiver, setReceiver] = useState(
        values && values['account'] ? values['account'] : '',
    )

    const changePrice = (e) => {
        const val = e.target.value
        if (/^\d*\.?\d*$/.test(val)) {
            setPrice(val)
        }
    }

    const changeReceiver = (e) => {
        const val = e.target.value
        setReceiver(val)
    }

    const changeDays = (e) => {
        const val = e.target.value
        if (/^\d*$/.test(val)) setDays(val ? Math.min(parseInt(val), 10) : val)
    }

    const rentingDisabled =
        !userName ||
        !receiver ||
        !days ||
        !price ||
        (price * (payInHoney ? honeyFactor : 1.0) * (100.0 / fees)) / days >
            10000.0 ||
        price < 0.025 ||
        (cpu4uAccount &&
            parseFloat(cpu4uAccount.balance) <
                (price * (payInHoney ? honeyFactor : 1.0) * (100.0 / fees)) /
                    days)

    useEffect(() => {}, [fees])

    const getHoneyFactor = async () => {
        const body = {
            code: 'nfthivecpu4u',
            index_position: 'primary',
            json: 'true',
            key_type: 'i64',
            limit: 1,
            lower_bound: '',
            upper_bound: '',
            reverse: 'true',
            scope: 'nfthivecpu4u',
            show_payer: 'false',
            table: 'honeyfactor',
            table_key: '',
        }

        const url =
            process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                ? config.testapi + '/v1/chain/get_table_rows'
                : state.api + '/v1/chain/get_table_rows'
        const res = await post(url, body)

        if (
            res &&
            res.status === 200 &&
            res.data &&
            res.data.rows &&
            res.data.rows.length > 0
        ) {
            setHoneyFactor(parseFloat(res.data.rows[0]['factor']))
        }
    }

    const getFees = async () => {
        const body = {
            code: 'nfthivecpu4u',
            index_position: 'primary',
            json: 'true',
            key_type: 'i64',
            limit: 1,
            lower_bound: '',
            upper_bound: '',
            reverse: 'true',
            scope: 'nfthivecpu4u',
            show_payer: 'false',
            table: 'fees',
            table_key: '',
        }

        const url =
            process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                ? config.testapi + '/v1/chain/get_table_rows'
                : state.api + '/v1/chain/get_table_rows'
        const res = await post(url, body)

        if (
            res &&
            res.status === 200 &&
            res.data &&
            res.data.rows &&
            res.data.rows.length > 0
        ) {
            setFees(parseFloat(res.data.rows[0]['fees']))
        }
    }

    const ProgressBar = ({ account, color }) => {
        const progressPercentage =
            account.cpu.max > 0 ? account.cpu.used / account.cpu.max : 0
        return (
            <div className={cn('px-5 h-full')}>
                <div
                    className={cn(
                        'h-full w-32 bg-primaryt rounded overflow-hidden',
                    )}
                >
                    <div
                        style={{ width: `${progressPercentage * 100}%` }}
                        className={cn(
                            'h-full dark:!text-white text-black font-bold',
                            color,
                        )}
                    >
                        <div className={cn('px-1 ')}>
                            {formatPercentage(progressPercentage)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const [userAccount, setUserAccount] = useState({
        cpu: {
            used: 0,
            available: 0,
            max: 0,
        },
        balance: 0,
    })

    const [cpu4uAccount, setCpu4uAccount] = useState({
        cpu: {
            used: 0,
            available: 0,
            max: 0,
        },
        balance: 0,
    })

    const [pool1Account, setPool1Account] = useState({
        cpu: {
            used: 0,
            available: 0,
            max: 0,
        },
        balance: 0,
        refund: null,
    })

    const [pool2Account, setPool2Account] = useState({
        cpu: {
            used: 0,
            available: 0,
            max: 0,
        },
        balance: 0,
        refund: null,
    })

    const [pool3Account, setPool3Account] = useState({
        cpu: {
            used: 0,
            available: 0,
            max: 0,
        },
        balance: 0,
        refund: null,
    })

    const parseAccount = (res, setter) => {
        if (res && res.status === 200) {
            const data = res['data']

            const balance = data['core_liquid_balance']
                ? data['core_liquid_balance'].replace(' WAX', '')
                : '0'

            const cpu = data['cpu_limit']

            const staked = data['voter_info'] ? data['voter_info']['staked'] : 0

            const refund = data['refund_request']
                ? {
                      refundDate: moment
                          .utc(data['refund_request']['request_time'])
                          .add(3, 'days')
                          .local(),
                      netAmount: data['refund_request']['net_amount']
                          ? parseFloat(
                                data['refund_request']['net_amount'].replace(
                                    ' WAX',
                                    '',
                                ),
                            )
                          : 0,
                      cpuAmount: data['refund_request']['cpu_amount']
                          ? parseFloat(
                                data['refund_request']['cpu_amount'].replace(
                                    ' WAX',
                                    '',
                                ),
                            )
                          : 0,
                  }
                : null

            setter({
                cpu: cpu,
                balance: balance,
                refund: refund,
                staked: staked,
            })
        }
    }

    const rentCPUStatic = async (days, cost) => {
        setMessage('')
        setIsLoading(true)

        let renter = receiver
        if (!renter) renter = userName

        const price = (cost * days) / (100.0 / fees)

        try {
            const result = await activeUser.session.transact(
                {
                    actions: [
                        getBoostAction(activeUser),
                        {
                            account: payInHoney
                                ? 'nfthivehoney'
                                : 'eosio.token',
                            name: 'transfer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                from: userName,
                                to: CPU_ACCOUNTNAME,
                                quantity: payInHoney
                                    ? `${parseFloat(price).toFixed(4)} HONEY`
                                    : `${parseFloat(price).toFixed(8)} WAX`,
                                memo: `days:${days};receiver:${renter}`,
                            },
                        },
                    ],
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )
            setMessage(
                `♥ Thank you! Successfully rented ${formatWAX(
                    (price *
                        (payInHoney ? honeyFactor : 1.0) *
                        (100.0 / fees)) /
                        days,
                )} for ${userName}`,
            )
            setTimeout(() => {
                getAccountInfo(userName, setUserAccount)
                getAccountInfo(CPU_ACCOUNTNAME, setCpu4uAccount)
            }, 1000)
        } catch (e) {
            console.error(e)
            setError(e.message)
        } finally {
            setIsLoading(false)
        }
    }

    const rentCPU = async () => {
        setMessage('')
        setIsLoading(true)

        if (!receiver || !days || !price ? 'disabled' : '') return

        try {
            const result = await activeUser.session.transact(
                {
                    actions: [
                        getBoostAction(activeUser),
                        {
                            account: payInHoney
                                ? 'nfthivehoney'
                                : 'eosio.token',
                            name: 'transfer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                from: userName,
                                to: CPU_ACCOUNTNAME,
                                quantity: payInHoney
                                    ? `${parseFloat(price).toFixed(4)} HONEY`
                                    : `${parseFloat(price).toFixed(8)} WAX`,
                                memo: `days:${days};receiver:${receiver}`,
                            },
                        },
                    ],
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )
            setMessage(
                `♥ Thank you! Successfully rented ${formatWAX(
                    (price * (payInHoney ? honeyFactor : 1.0) * (100 / fees)) /
                        days,
                )} for ${receiver}`,
            )
            setTimeout(() => {
                getAccountInfo(userName, setUserAccount)
                getAccountInfo(CPU_ACCOUNTNAME, setCpu4uAccount)
            }, 1000)
        } catch (e) {
            console.error(e)
            setError(e.message)
        } finally {
            setIsLoading(false)
        }
    }

    const getAccountInfo = async (name, setter) => {
        const body = {
            account_name: name,
        }

        const url =
            process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                ? config.testapi + '/v1/chain/get_table_rows'
                : state.api + '/v1/chain/get_account'

        post(url, body).then((res) => parseAccount(res, setter))
    }

    const dismissError = () => {
        setError(null)
    }

    const parseHoneyBalance = (res) => {
        if (res && res.status === 200) {
            let balance = 0
            const data = res.data

            if (data && Object.keys(data).includes('rows')) {
                data['rows'].map((row) => {
                    if (row['balance'].includes(' HONEY'))
                        balance += parseFloat(
                            row['balance'].replace(' HONEY', ''),
                        )
                })
            }

            setHoneyBalance(balance)
        }
    }

    useEffect(() => {
        if (userName) {
            getAccountInfo(userName, setUserAccount)
            if (!receiver) setReceiver(userName)
        }
        getAccountInfo(CPU_ACCOUNTNAME, setCpu4uAccount)
        getAccountInfo(CPU_POOL1NAME, setPool1Account)
        getAccountInfo(CPU_POOL2NAME, setPool2Account)
        getAccountInfo(CPU_POOL3NAME, setPool3Account)
        getFees()
        getHoneyFactor()
        getHoneyBalance(userName, state).then(parseHoneyBalance)
    }, [userName])

    const cnLeftCol = 'text-left px-5 pb-3'
    const cnProgressBar = 'pb-3 '

    const pools = [
        {
            name: 'Pool 1',
            pool: pool1Account,
            contract: CPU_POOL1NAME,
        },
        {
            name: 'Pool 2',
            pool: pool2Account,
            contract: CPU_POOL2NAME,
        },
        {
            name: 'Pool 3',
            pool: pool3Account,
            contract: CPU_POOL3NAME,
        },
    ]

    const quickOptions = [
        {
            stake: 100,
            days: 1,
        },
        {
            stake: 100,
            days: 3,
        },
        {
            stake: 100,
            days: 6,
        },
        {
            stake: 200,
            days: 1,
        },
        {
            stake: 200,
            days: 3,
        },
        {
            stake: 200,
            days: 6,
        },
        {
            stake: 500,
            days: 1,
        },
        {
            stake: 500,
            days: 3,
        },
        {
            stake: 500,
            days: 6,
        },
    ]

    const handlePayChange = (e) => {
        console.error(e)
        setPayInHoney(e.target.checked)
    }
    const [, , { login }] = useSharedState()

    return (
        <Page
            id="Cpu4uPage"
            title={
                'NFTHive.io WAX CPU Renting - 2 Million WAX available - 0.1% - 0.5% Fees'
            }
            description={
                'Rent CPU from us! Power your WAX account to do unlimited transactions. ' +
                'Perfect for P2E, Bulk Selling NFTs and more. ' +
                'Most reliable renting Service on WAX!'
            }
            {...props}
        >
            <div className="mx-3">
                <div className="flex justify-center pt-10 pb-4 text-3xl font-bold text-black dark:text-white">
                    {t('cpu.rent_cpu_from_us')}
                </div>
                <div className="flex justify-center pb-10 font-bold text-black text-1xl dark:text-white">
                    {t('cpu.cheapest_cpu_renting')}
                </div>
                <div>
                    {userName ? (
                        <div>
                            <div className="flex justify-center pb-3">
                                Hey
                                <b
                                    className={
                                        'ml-1 font-bold md:font-semibold'
                                    }
                                >
                                    {userName}
                                </b>
                                !
                            </div>
                            <div className="pb-3">
                                <div className={' grid grid-cols-1 mx-auto'}>
                                    <div
                                        className={'w-full flex justify-center'}
                                    >
                                        {t('cpu.your_balances_are')}:
                                    </div>
                                    <div
                                        className={
                                            'text-black dark:!text-neutral font-bold md:font-semibold flex justify-center'
                                        }
                                    >
                                        {formatWAX(userAccount.balance)}
                                    </div>
                                    {honeyBalance ? (
                                        <div
                                            className={
                                                'text-black dark:!text-neutral font-bold md:font-semibold flex justify-center'
                                            }
                                        >
                                            {formatHoney(honeyBalance)}
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                            <div className="flex justify-center ">
                                <div className="grid grid-cols-2">
                                    <div className={cnLeftCol}>
                                        {t('cpu.your_cpu_usage')}:
                                    </div>
                                    <div className={cnProgressBar}>
                                        <ProgressBar
                                            account={userAccount}
                                            color={'bg-primary'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className={'flex'}>
                            <div
                                onClick={() => login()}
                                className={cn(
                                    'mx-auto text-primary text-2xl cursor-pointer underline hover:font-bold hover:underline pb-5',
                                )}
                            >
                                {t('cpu.please_log_in_to_continue')}
                            </div>
                        </div>
                    )}
                    <div className="py-4">
                        <div className={'flex justify-center'}>
                            {t('cpu.available_cpu_to_rent')}
                        </div>
                        <div
                            className={
                                'flex justify-center dark:text-white text-black ml-2 font-bold text-2xl'
                            }
                        >
                            {formatWAX(cpu4uAccount.balance)}
                        </div>
                    </div>
                    <div className="flex justify-center pb-3 mt-5">
                        {t('cpu.how_much_cpu_do_you_need')}
                    </div>
                    <div className={cn('flex justify-center p-3')}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={payInHoney}
                                    onChange={handlePayChange}
                                    disabled={honeyBalance ? false : 'disabled'}
                                />
                            }
                            label={t('cpu.pay_in_x', { x: '$HONEY' })}
                            labelPlacement="start"
                        />
                    </div>
                    <div className="flex justify-center pb-3 my-5">
                        <div>
                            <Tooltip
                                title={t(
                                    'cpu.earn_honey_by_trading_on_nfthive',
                                )}
                            >
                                <img
                                    className={'w-18 mx-auto pb-3'}
                                    src={'/Logo_HONEY.png'}
                                />
                            </Tooltip>
                            <Link
                                href={
                                    'https://swap.tacocrypto.io/swap?output=HONEY-nfthivehoney&input=WAX-eosio.token'
                                }
                                external={true}
                            >
                                <div className={'w-full underline flex mb-2'}>
                                    <div className={'text-center'}>
                                        {t('cpu.swap_honey_on_taco')}
                                    </div>
                                    <div className={'ml-2 h-6 w-6'}>
                                        <img src={'/tacoswap-logo-beta.svg'} />
                                    </div>
                                </div>
                            </Link>
                            <Link
                                href={
                                    'https://wax.alcor.exchange/trade/honey-nfthivehoney_wax-eosio.token'
                                }
                                external={true}
                            >
                                <div className={'w-full underline flex mb-2'}>
                                    <div className={'text-center'}>
                                        {t('cpu.get_honey_on_alcor')}
                                    </div>
                                    <div className={'ml-2 h-6 w-6'}>
                                        <img src={'/alcor.svg'} />
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={cn('flex justify-center p-3 font-bold')}>
                        {t('cpu.honey_factor_get_x_times', { x: honeyFactor })}
                    </div>
                    <div className="flex justify-center">
                        <div className="mx-1">
                            <Input
                                variant="faded"
                                disabled={!userName}
                                label={
                                    payInHoney
                                        ? t('cpu.x_to_pay', { x: 'HONEY' })
                                        : t('cpu.x_to_pay', { x: 'WAX' })
                                }
                                value={price}
                                onChange={changePrice}
                                InputProps={{
                                    endAdornment: userName && (
                                        <InputAdornment position="end">
                                            {payInHoney ? 'HONEY' : 'WAX'}
                                        </InputAdornment>
                                    ),
                                }}
                                error={userName && !floatRegEx.test(price)}
                            />
                        </div>

                        <div className="mx-1">
                            <Input
                                variant="faded"
                                disabled={!userName}
                                label={t('cpu.days_to_rent')}
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                onChange={changeDays}
                                value={days}
                                error={userName && !days}
                            />
                        </div>

                        <div className="mx-1">
                            <Input
                                variant="faded"
                                disabled={!userName}
                                label={t('cpu.receiver')}
                                type="text"
                                onChange={changeReceiver}
                                value={receiver}
                                error={userName && !receiver}
                            />
                        </div>
                    </div>
                    <div className="flex justify-center pb-3 mt-4 text-xl fond-semibold">
                        <div>
                            At{' '}
                            <b className={'font-bold md:font-semibold'}>
                                {formatPercentage(fees / 100.0)}
                            </b>{' '}
                            Fees, this will grant you:
                        </div>
                    </div>
                    <div className="flex justify-center pb-3 text-black dark:text-white">
                        <div
                            className={
                                'font-bold md:font-semibold dark:text-white text-black mx-1'
                            }
                        >
                            {formatWAX(
                                price && days
                                    ? (price *
                                          (payInHoney ? honeyFactor : 1.0) *
                                          (100 / fees)) /
                                          days
                                    : 0,
                            )}
                        </div>
                        <div>staked to CPU for</div>
                        <div
                            className={
                                'font-bold md:font-semibold dark:text-white text-black mx-1'
                            }
                        >
                            {days}
                        </div>
                        <div>Days to</div>
                        <div
                            className={
                                'font-bold md:font-semibold dark:text-white text-black mx-1'
                            }
                        >
                            {receiver}
                        </div>
                    </div>
                    <div className={'relative w-1/2 mx-auto'}>
                        <div className={'flex justify-center'}>
                            {error ? (
                                <ErrorNote
                                    error={error}
                                    onClick={dismissError}
                                />
                            ) : (
                                ''
                            )}
                            {isLoading ? (
                                <LoadingIndicator />
                            ) : (
                                <div>
                                    <div className="flex justify-center">
                                        <Button
                                            variant="outlined"
                                            onClick={rentCPU}
                                            disabled={
                                                rentingDisabled
                                                    ? 'disabled'
                                                    : ''
                                            }
                                        >
                                            {t('cpu.rent_now')}
                                        </Button>
                                    </div>
                                    <Collapse in={rentingDisabled}>
                                        <div className="my-5">
                                            <Alert severity="error">
                                                {!userName
                                                    ? 'Please Log in First'
                                                    : !receiver
                                                    ? 'Please Enter a Receiver'
                                                    : !days
                                                    ? 'Please Enter Days to Rent'
                                                    : !price
                                                    ? `Please choose how much ${
                                                          payInHoney
                                                              ? 'HONEY'
                                                              : 'WAX'
                                                      } you wish to pay`
                                                    : (price *
                                                          (payInHoney
                                                              ? honeyFactor
                                                              : 1.0) *
                                                          (100.0 / fees)) /
                                                          days >
                                                      10000.0
                                                    ? 'You can only rent 10000 WAX or less'
                                                    : price < 0.025
                                                    ? 'Need to rent for at least 0.025 WAX to avoid Spam'
                                                    : cpu4uAccount &&
                                                      parseFloat(
                                                          cpu4uAccount.balance,
                                                      ) <
                                                          (price *
                                                              (payInHoney
                                                                  ? honeyFactor
                                                                  : 1.0) *
                                                              (100.0 / fees)) /
                                                              days
                                                    ? 'Not enough CPU available to rent'
                                                    : ''}
                                            </Alert>
                                        </div>
                                    </Collapse>
                                </div>
                            )}
                        </div>
                        {!isLoading && (
                            <div className={'my-4 flex justify-center'}>
                                {t('cpu.or_quickly_buy_for_yourself')}
                            </div>
                        )}
                        {!isLoading && (
                            <div
                                className={
                                    'grid grid-cols-1 md:grid-cols-3 gap-2'
                                }
                            >
                                {quickOptions.map((option) => (
                                    <Button
                                        style={{ textTransform: 'none' }}
                                        variant="outlined"
                                        onClick={() =>
                                            rentCPUStatic(
                                                option.days,
                                                option.stake,
                                            )
                                        }
                                        disabled={!userName}
                                    >
                                        Pay{' '}
                                        {payInHoney
                                            ? formatHoney(
                                                  (option.stake * option.days) /
                                                      (100.0 / fees),
                                              )
                                            : formatWAX(
                                                  (option.stake * option.days) /
                                                      (100.0 / fees),
                                              )}{' '}
                                        for <br />
                                        {option.stake *
                                            (payInHoney
                                                ? honeyFactor
                                                : 1.0)}{' '}
                                        WAX - {option.days} Day
                                        {option.days > 1 ? 's' : ''}
                                    </Button>
                                ))}
                            </div>
                        )}
                        {message && (
                            <div className="my-2">
                                <Alert severity="success">{message}</Alert>
                            </div>
                        )}
                    </div>
                    <h1
                        className={
                            'text-base font-bold md:font-semibold mt-10 mb-5 flex justify-center'
                        }
                    >
                        {t('cpu.current_pools')}:
                    </h1>
                    {pools.map((pool) => (
                        <div className="grid justify-center w-full grid-cols-3 pb-3 mx-auto md:w-1/2">
                            <div className={'text-left'}>Pool Name:</div>
                            <div
                                className={
                                    'dark:text-white text-black ml-2 font-bold md:font-semibold col-span-2 text-left'
                                }
                            >
                                {pool.name} / {pool.contract}
                            </div>
                            <div className={'text-left'}>Staked:</div>
                            <div
                                className={
                                    'dark:text-white text-black ml-2 font-bold md:font-semibold col-span-2 text-left'
                                }
                            >
                                {formatNumber(pool.pool.staked / 100000000.0)}
                                {' WAX'}
                            </div>
                            {pool.pool.refund && pool.pool.refund.refundDate ? (
                                <div className={'text-left'}>Refunding:</div>
                            ) : (
                                ''
                            )}
                            {pool.pool.refund && pool.pool.refund.refundDate ? (
                                <div
                                    className={
                                        'dark:text-white text-black ml-2 font-bold md:font-semibold col-span-2 text-left'
                                    }
                                >
                                    {formatNumber(pool.pool.refund.cpuAmount)}
                                    {' WAX '}
                                    {pool.pool.refund &&
                                    pool.pool.refund.refundDate
                                        ? ` ~ ${pool.pool.refund.refundDate.toLocaleString()}`
                                        : ''}
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    ))}
                    <h1
                        className={
                            'text-base font-bold md:font-semibold mt-10 mb-5 flex justify-center'
                        }
                    >
                        {t('cpu.total_pool_balance')}:
                    </h1>
                    <div className="flex justify-center w-full pb-3 mx-auto md:w-1/2">
                        {formatWAX(
                            pools
                                .map(
                                    (pool) =>
                                        pool.pool.staked / 100000000.0 +
                                        (pool.pool.refund
                                            ? pool.pool.refund.cpuAmount
                                            : 0),
                                )
                                .reduce((a, b) => a + b) + '',
                        )}
                        {' / '}
                        {formatWAX(
                            pools
                                .map(
                                    (pool) =>
                                        pool.pool.staked / 100000000.0 +
                                        (pool.pool.refund
                                            ? pool.pool.refund.cpuAmount
                                            : 0),
                                )
                                .reduce((a, b) => a + b) +
                                parseFloat(cpu4uAccount.balance) +
                                '',
                        )}
                    </div>
                </div>
            </div>
        </Page>
    )
}

export default Cpu4uPage
